// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AP_container
{
    background-color: white;
    /* border-radius: 2vh; */
    border: 0;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    display: flex;
    flex-direction: column;
   /* min-width: 80%; */
}
.AP_title
{
    /* color: #5665e9; */
    text-align: center;
    margin-bottom: 7%;
}
.AP_ModuleProjectLesson{
    /* background-color: #dae8ff; */
    border-radius: 2vh;
    padding: 1%;
    height: auto;
    width: 40%;
    float: left;
    margin: 1vh;
}
.AP_Projects
{
    list-style: none;

}

.AP_Icon,.AP_Score,.AP_Time
{
    /* background-color: #aec7f0; */
    border-radius: 7vh;
    border: 2px solid white;
    padding: 2%;
    margin-left: 2%;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
    font-size: 2vh;
    font-weight: bold;
    width: 100%;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  100% { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/Actions/ActivitiesAndProjects.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,sBAAsB;GACvB,oBAAoB;AACvB;AACA;;IAEI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,WAAW;AACf;AACA;;IAEI,gBAAgB;;AAEpB;;AAEA;;IAEI,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,0CAA0C;IAC1C,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":[".AP_container\n{\n    background-color: white;\n    /* border-radius: 2vh; */\n    border: 0;\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n   /* min-width: 80%; */\n}\n.AP_title\n{\n    /* color: #5665e9; */\n    text-align: center;\n    margin-bottom: 7%;\n}\n.AP_ModuleProjectLesson{\n    /* background-color: #dae8ff; */\n    border-radius: 2vh;\n    padding: 1%;\n    height: auto;\n    width: 40%;\n    float: left;\n    margin: 1vh;\n}\n.AP_Projects\n{\n    list-style: none;\n\n}\n\n.AP_Icon,.AP_Score,.AP_Time\n{\n    /* background-color: #aec7f0; */\n    border-radius: 7vh;\n    border: 2px solid white;\n    padding: 2%;\n    margin-left: 2%;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);\n    font-size: 2vh;\n    font-weight: bold;\n    width: 100%;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  100% { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
